import { Container, Row, Col, ListGroup, Form, Button, Modal, Spinner } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import Card from '../components/Card'
import API from '../api/api'
import Actions from '../redux/actions'
import { useEffect, useState } from 'react'
import AddUserForm from '../components/AddUserForm'
import AddNotifyNum from '../components/AddNotifyNum'
import { AiFillChrome, AiFillCheckCircle, AiFillCloseCircle } from 'react-icons/ai'
import { FaEdge } from 'react-icons/fa'
import io from 'socket.io-client';

export default function User(props) {

    const user = useSelector(state => state.user)
    const accounts = useSelector(state => state.accounts)
    const dispatch = useDispatch()

    const [loading, setLoading] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [showNumber, setShowNumber] = useState(false)
    const [socket, setSocket] = useState(null)
    const [btnDisabled, setBtnDisabled] = useState(false)

    const _flipDevice = async (userId, deviceId) => {
        setLoading(true)
        const res = await API.flipDevice(userId, deviceId)
        if (res.error) {
            dispatch(Actions.setToast('🚨 Out of Licenses 🚨', `You only have ${user?.licenses} device licenses. Add a license in settings or deactivate a device before adding this one.🚨`))
        } else {
            if (userId === user?._id) {
                dispatch(Actions.setUser(res.user))

            } else {
                dispatch(Actions.updateAccount(res.user))
            }
            if (res.user?.devices.find(dev => dev._id === deviceId).isActive) {
                dispatch(Actions.setToast('Device Activated ✅', `This device is now using one of your licenses`))
            } else {
                dispatch(Actions.setToast('Device Deactivated ✅', `This device is no longer using one of your licenses`))
            }

            socket.emit('device-change', { userId, device: res.user.devices.find(dev => dev._id === deviceId), isActive: res.user?.devices.find(dev => dev._id === deviceId).isActive })


        }
        setLoading(false)
    }

    const _removeNotifyNumber = async (userId, number) => {
        const updatedUser = await API.removeNotifyNumber(userId, number)
        dispatch(Actions.updateAccount(updatedUser))
        setLoading(false)
        dispatch(Actions.setToast(`Number Removed`, 'They will no longer receive text updates'))
    }

    const _resendInvite = async (userId) => {
        setBtnDisabled(true)
        await API.resendInvite(userId)
        dispatch(Actions.setToast(`Invite Resent`, 'Another invite email has been sent'))
        setBtnDisabled(false)

    }


    useEffect(() => {
        document.title = 'ScamWall | User Management'
        const newSocket = io(process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : 'https://api.scamwall.io', {
            query: {
                token: localStorage.getItem('refreshToken')
            }
        })
        setSocket(newSocket);
        return () => newSocket.close();
    }, [])


    const _devices = (user) => {
        if(!user){
            return
        }
        if (!user.devices?.find(dev => dev.isWindows)) {
            return <></>
        } else {

            return <>
                <Row className='justify-content-center text-center'>
                    <Col xs={1} className='my-auto'>
                        <h3 className='my-auto'><AiFillChrome /></h3>
                    </Col>
                    <Col xs={2} className='my-auto'>
                        {user?.devices?.find(dev => dev.isActive && dev.browser === 'CHROME') ? < AiFillCheckCircle className='text-success' /> : <AiFillCloseCircle className='text-danger' />}
                    </Col>
                </Row>
                <Row className='justify-content-center text-center mb-3'>
                    <Col xs={1} className='my-auto'>
                        <h3 className='my-auto'><FaEdge /></h3>
                    </Col>
                    <Col xs={2} className='my-auto'>
                        {user.devices?.find(dev => dev.isActive && dev.browser === 'EDGE') ? < AiFillCheckCircle className='text-success' /> : <AiFillCloseCircle className='text-danger' />}
                    </Col>
                </Row>
                {user.devices.find(dev => dev.isActive && dev.browser === 'CHROME') && !user.devices.find(dev => dev.isActive && dev.browser === 'EDGE') && <>
                    <p className='text-danger mx-3'>{user.fName.toUpperCase()} NEEDS TO INSTALL SCAMWALL ON EDGE</p>
                </>}
            </>
        }

    }
    return (
        <Container fluid className='pt-4 ps-4 m-0'>

            <h1 className='text-start'>User Management</h1>
            <p className='text-start'>Add/Remove Users, and view devices</p>
            <div className='text-end mb-2 me-3'>
                <Button onClick={() => setShowModal(true)}>Add User</Button>
            </div>
            {accounts?.length === 0 && <p className='lead'>Add Your First User Today!</p>}
            {loading && <div className='text-center'>
                <Spinner animation='border' />
            </div>}
            <Row className='flex-wrap'>
                <Col md={4} className='mt-2'>
                    <Card>
                        <h5 className='weight-bold'>{user?.fName} {user?.lName}</h5>
                        <p><a href={`mailto:${user?.email}`}>{user?.email}</a></p>
                        <p><b >Devices: </b>{user?.devices?.length}</p>
                        <p><b >Active Licenses: </b>{user?.devices?.filter(dev => dev.isActive)?.length || 0}</p>

                        {_devices(user)}
                        <ListGroup>
                            {user?.devices.map(dev => (
                                <ListGroup.Item className='text-center'>
                                    <p><b>{dev.name}</b></p>
                                    <Row>
                                        <Col md={8} className='mx-auto'>
                                            <Form.Check
                                                className='text-center mx-auto'
                                                type="switch"
                                                checked={dev.isActive}
                                                id="custom-switch"
                                                label={dev.isActive ? 'Active License' : 'Inactive License'}
                                                onClick={() => _flipDevice(user?._id, dev._id)}
                                            />
                                        </Col>
                                    </Row>

                                </ListGroup.Item>
                            ))}
                        </ListGroup>
                        <p><small>(Your Account)</small></p>

                    </Card>
                </Col>
                {accounts?.map(account => (
                    <Col md={4} className='mt-2'>
                        <Card>
                            <h5 className='weight-bold'>{account.fName} {account.lName}</h5>
                            <p><a href={`mailto:${account.email}`}>{account.email}</a></p>
                            <p><b >Created: </b>{new Date(account.createdAt).toLocaleDateString('en-US', { dateStyle: 'short' })}</p>
                            <p><b >Devices: </b>{account.devices?.length}</p>
                            <p><b >Active Licenses: </b>{account.devices?.filter(dev => dev.isActive)?.length || 0}</p>
                            {_devices(account)}

                            <ListGroup>
                                {account.devices.map(dev => (
                                    <ListGroup.Item className='text-center'>
                                        <p><b>{dev.name}</b></p>
                                        <Row>
                                            <Col md={8} className='mx-auto'>
                                                <Form.Check
                                                    className='text-center mx-auto'
                                                    type="switch"
                                                    checked={dev.isActive}
                                                    id="custom-switch"
                                                    label={dev.isActive ? 'Active License' : 'Inactive License'}
                                                    onClick={() => _flipDevice(account._id, dev._id)}
                                                />
                                            </Col>
                                        </Row>

                                    </ListGroup.Item>
                                ))}
                            </ListGroup>
                            <hr />
                            <p><b >Notification Numbers</b></p>
                            {(!account?.notifyNumbers || account.notifyNumbers.length === 0) && <p className='text-center'>You are the only one receiving text updates</p>}
                            <ListGroup className='mb-3'>
                                {account.notifyNumbers.map(num => (
                                    <ListGroup.Item className='text-center'>
                                        <Row>
                                            <Col className='my-auto'>
                                                <p className='mb-0 my-auto'><b>{num}</b></p>
                                            </Col>
                                            <Col>
                                                <Button variant='link noDecoration' onClick={() => _removeNotifyNumber(account._id, num)}>Remove</Button>
                                            </Col>
                                        </Row>
                                    </ListGroup.Item>
                                ))}
                            </ListGroup>
                            <Button variant='primary' onClick={() => { setShowNumber(true); dispatch(Actions.setSelectedUser(account)) }}>Add Number</Button>
                            <br />

                            <hr />
                            {account?.isPending && <>
                                <p><small>{account?.fName}'s account has not been setup yet</small></p>
                                <Button variant='info' disabled={btnDisabled} onClick={() => _resendInvite(account?._id)}>Resend Invite</Button>
                                <hr />

                            </>}
                            <Button variant='link' className='mt-4 text-danger noDecoration'>Delete User</Button>
                        </Card>
                    </Col>

                ))}
            </Row>

            <Modal show={showModal} onHide={() => setShowModal(false)} size='md'>
                <Modal.Header closeButton>
                    <Modal.Title>Create New User</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <AddUserForm close={() => setShowModal(false)} />
                </Modal.Body>

            </Modal>

            <Modal show={showNumber} onHide={() => setShowNumber(false)} size='md'>
                <Modal.Header closeButton>
                    <Modal.Title>Add Phone Number</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <AddNotifyNum close={() => setShowNumber(false)} />
                </Modal.Body>

            </Modal>
        </Container>

    )
}